// IndexedDB (Dexie) store for the Web Register — mirrors the POS Room DB.
// Holds the full catalog + promotions + reference data synced from the Go bundle (+ PHP taxes),
// so all register reads are local. See spec §5.2.

import Dexie from "dexie";

export const db = new Dexie("quickvee_web_register");

// v1 schema. Products keyed by id with indexes for lookup/search; `merchant` lets us scope/clear
// per merchant. `meta` holds the sync watermark + merchant marker. Other tables are id-keyed.
db.version(1).stores({
  meta: "key", // { key, value } — sync watermark, active merchant
  products: "id, title, upc, merchant", // contains-search uses a filtered scan; upc index aids exact scan
  categories: "id",
  bogos: "id",
  coupons: "id",
  matches: "id", // mix & match
  taxes: "id", // id -> {title, displayname, percent}
  settings: "key", // { key, value } — store/register settings, loyalty config
});

// v2: offline order queue — a paid order is persisted here BEFORE the saveOrderPos call, and a
// background worker flushes it (retrying until the server confirms body.status===true). Survives
// merchant switch / catalog re-sync (NOT cleared by clearAll) so a queued order is never lost.
db.version(2).stores({
  offlineOrders: "orderId, status, createdAt", // { orderId, payload, kind, status, createdAt, attempts, lastError }
});

export const META_WATERMARK = "inventory_timestamp";
export const META_MERCHANT = "active_merchant";

export async function getMeta(key) {
  const row = await db.meta.get(key);
  return row ? row.value : undefined;
}

export async function setMeta(key, value) {
  await db.meta.put({ key, value });
}

// Clear all register data (e.g. merchant switch or forced re-sync).
export async function clearAll() {
  await Promise.all([
    db.products.clear(),
    db.categories.clear(),
    db.bogos.clear(),
    db.coupons.clear(),
    db.matches.clear(),
    db.taxes.clear(),
    db.settings.clear(),
    db.meta.clear(),
  ]);
}
